import { RouterProvider } from "react-router";
import { PostHogProvider } from "posthog-js/react";
import { ThemeProvider } from "./components/ThemeProvider";
import { BurrowProvider } from "./components/BurrowStore";
import { router } from "./routes";
import { AuthProvider } from "./lib/auth/AuthProvider";
import { SubscriptionProvider } from "./lib/useSubscription";
import { ResurfaceProvider } from "./lib/useResurface";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { UpdatePrompt } from "./components/UpdatePrompt";
import { posthog } from "./lib/posthog";

export default function App() {
  return (
    <PostHogProvider client={posthog}>
      <ThemeProvider>
        {/* Outside the router and the app ErrorBoundary so the offer to reload
            survives a crash in either. */}
        <UpdatePrompt />
        <AuthProvider>
          <SubscriptionProvider>
          <BurrowProvider>
            <ResurfaceProvider>
              <ErrorBoundary>
                <RouterProvider router={router} />
              </ErrorBoundary>
            </ResurfaceProvider>
          </BurrowProvider>
          </SubscriptionProvider>
        </AuthProvider>
      </ThemeProvider>
    </PostHogProvider>
  );
}
